import { unescapeHtmlTags } from '../../../utils/helpers'

const reportPage = {
    title: '',
    id: '',
    questions: [],
}

const toReportPage = (page) => (
    Object.assign({}, reportPage, {
        title: unescapeHtmlTags(page.title),
        id: page.id,
        questions: page.questions.map((q) => ({
            pageQuestionId: q.id,
            parentId: q.parentId,
            optionSetY: q.optionSetY,
            isHidden: q.isHidden,
            isDataImport: q.isDataImport,
            hasPrepopulatedData: q.hasPrepopulatedData,
            isAiCodingDisabled: q.isAiCodingDisabled,
        })),
    })
)

export {
    toReportPage,
}
